const state = {
    show: false
}

const mutations = {
    setState: (state, {key, value}) => {
        state[key] = value;
    }
}

const actions = {}

const getters = {
    show: state => state.show
}

export default {
    namespaced: true,

    state,
    mutations,
    actions,
    getters
}